// extracted by mini-css-extract-plugin
export default {"main":"Menu_main__Ri-1R","field":"Menu_field__EvN+o"};